export enum PageTab {
  Users = 'users',
  Invitations = 'invitations',
}
